import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobStatusAuditLog.List.IRequest;
type Response = Api.Core.ClaimJobStatusAuditLog.List.IResponse;
type Headers = Api.Core.ClaimJobStatusAuditLog.List.IHeaders;
const url = '/api/Claims/ClaimJobStatusAuditLog';
export default async function claimJobStatusAuditLogListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
